import { Collapse } from "@mui/material";
import { InputCheck } from "controls";
import React, { useEffect } from "react";

const SalesHistoryAccess = ({ values, setValues }) => {
  useEffect(() => {
    if (!values.id) {
      values.salesHistoryAccess
        ? setValues((j) => ({
            ...j,
            salesHistory: {
              returnSale: true,
              printReceipt: true,
              void: true,
            },
          }))
        : setValues((j) => ({
            ...j,
            salesHistory: {
              returnSale: false,
              printReceipt: false,
              void: false,
            },
          }));
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.salesHistoryAccess]);

  const handleInpChg = (e) => {
    const { name, checked } = e.target;
    setValues((j) => ({
      ...j,
      salesHistory: { ...j.salesHistory, [name]: checked },
    }));
  };

  return (
    <Collapse in={values.salesHistoryAccess || false}>
      <div className="ml-[3px] grid gap-1 mt-[2px] mb-[10px] !uppercase tracking-wider !pl-[10px] border-l-4 border-rounded">
        <InputCheck
          label="Return Sale"
          checked={values.salesHistory?.returnSale || false}
          name={"returnSale"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Print Receipt"
          checked={values.salesHistory?.printReceipt || false}
          name={"printReceipt"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Void"
          checked={values.salesHistory?.void || false}
          name={"void"}
          onClick={handleInpChg}
        />
      </div>
    </Collapse>
  );
};

export default SalesHistoryAccess;
